import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { bindPropStore } from "../bindProps";
import { renderChildren, text } from "../helpers";
import { chooseBalancedColumns, createBalancedTileLayout } from "./balancedTiles";

var root = $.from_html(`<div></div>`);

export default function Row($$anchor, $$props) {
	$.push($$props, true);

	let p = $.state($.proxy({}));

	$.user_effect(() => bindPropStore($$props.props, (next) => $.set(p, next, true)));

	function tileKind(children) {
		if (children.length < 2) return null;
		if (children.every((child) => child.classList.contains("slex-stat"))) return "stat";
		if (children.every((child) => child.classList.contains("slex-card"))) return "card";

		return null;
	}

	function numericStyle(value, fallback) {
		const n = Number.parseFloat(value);

		return Number.isFinite(n) ? n : fallback;
	}

	function renderBalancedChildren(node, options) {
		const children = renderChildren(node, $$props.ctx);
		let current = options;
		let pending = false;

		const reset = () => {
			node.classList.remove("slex-row--balanced-tiles");
			node.removeAttribute("data-tile-kind");
			node.style.removeProperty("--slex-balanced-cols");
			node.style.removeProperty("--slex-balanced-tracks");

			for (const child of Array.from(node.children)) {
				if (child instanceof HTMLElement) child.style.removeProperty("grid-column");
			}
		};

		const rebalance = () => {
			pending = false;
			reset();

			if (current.disabled) return;

			const directChildren = Array.from(node.children);
			const kind = tileKind(directChildren);

			if (!kind) return;

			const styles = getComputedStyle(node);
			const gap = numericStyle(styles.columnGap || styles.gap, 16);
			const targetTileWidth = numericStyle(styles.getPropertyValue("--slex-balanced-tile-width"), 136);
			const width = node.getBoundingClientRect().width || node.clientWidth;

			const columns = chooseBalancedColumns({
				itemCount: directChildren.length,
				containerWidth: width,
				targetTileWidth,
				gap
			});

			const layout = createBalancedTileLayout(directChildren.length, columns);

			node.classList.add("slex-row--balanced-tiles");
			node.dataset.tileKind = kind;
			node.style.setProperty("--slex-balanced-cols", String(layout.columns));
			node.style.setProperty("--slex-balanced-tracks", String(layout.tracks));

			directChildren.forEach((child, index) => {
				if (child instanceof HTMLElement) child.style.gridColumn = `span ${layout.spans[index]}`;
			});
		};

		const schedule = () => {
			if (pending) return;

			pending = true;
			queueMicrotask(rebalance);
		};

		const resizeObserver = new ResizeObserver(schedule);

		resizeObserver.observe(node);

		const mutationObserver = new MutationObserver(schedule);

		mutationObserver.observe(node, { childList: true });
		schedule();

		return {
			update(next) {
				current = next;
				schedule();
			},

			destroy() {
				resizeObserver.disconnect();
				mutationObserver.disconnect();
				children.destroy();
			}
		};
	}

	var div = root();
	let styles_1;

	$.action(div, ($$node, $$action_arg) => renderBalancedChildren?.($$node, $$action_arg), () => ({ disabled: !!($.get(p).align || $.get(p).justify) }));

	$.template_effect(
		($0, $1, $2, $3) => {
			$.set_class(div, 1, $0);
			$.set_attribute(div, 'id', $1);
			$.set_attribute(div, 'data-variant', $2);
			styles_1 = $.set_style(div, '', styles_1, $3);
		},
		[
			() => `slex-row${$.get(p).class ? ` ${text($.get(p).class)}` : ""}`,
			() => $.get(p).id ? text($.get(p).id) : undefined,
			() => $.get(p).variant || $.get(p).presentation
				? text($.get(p).variant ?? $.get(p).presentation)
				: undefined,

			() => ({
				'align-items': text($.get(p).align),
				'justify-content': text($.get(p).justify),
				gap: text($.get(p).gap)
			})
		]
	);

	$.append($$anchor, div);
	$.pop();
}